import { getCreditsBuy, getCreditsItems, getOrderStatus } from "@/apis/vip";
import { Button, Divider, message, Modal } from "antd"
import React, { useEffect, useRef, useState } from "react";
import './style.scss'
import PAY from "./image/pay.png";
import PAY_ICON from "./image/pay_icon.png";
import LOAD from "./image/load.png";
import SUCCESS from "./image/success.svg";
import { detectDevice } from "@/utils";
import { markSixEight618PaymentCompleted } from "@/utils/sixEight618Modal";
import { debounce } from "lodash";
import { QRCodeSVG } from 'qrcode.react'
import WX_PAY_ICON from "@/pages/Price/image/wechat_pay_icon.png";

const PAY_LINK = 'https://mi8elatzm1x.feishu.cn/wiki/Ms0cwYLRZiY3UbkKL7xckq9OnUe';
export const BuyComputeModal = ({ open, setOpen, onCannel, payCountObj, userOtherInfo, handleOpenCompute }: { open: boolean, setOpen: (val: boolean) => void, onCannel?: () => void, payCountObj: any, userOtherInfo: any, handleOpenCompute?: () => void }) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [selectCount, setSelectCount] = useState(0);
    const [selectCountPayObj, setSelectCountPayObj] = useState({} as any);
    const [selectCountPaySuccess, setSelectCountPaySuccess] = useState('');
    const [countList, setCountList] = useState([]);
    const isPc = detectDevice()

    const timer = useRef(null)
    // ALP 支付宝  WXP 微信
    const [payConfig, setPayConfig] = useState('ALP')
    
    // pay 算力
    const workCreditsBuy = async (count, type = 'ALP') => {
        const result = await getCreditsBuy({
            item_id: count,
            pay_channel: type
            // ...(discount ? {discount_code: discount} : {}),
        }).catch(err => {
            messageApi.open({
                type: 'error',
                content: err,
            });
        });
        if (result?.url && result?.id) {
            setPayConfig(type)
            setSelectCountPayObj(result)
        } else {
            setSelectCountPayObj({} as any)
        }
    };

    const handleCountSelect = (item) => {
        setSelectCount(item?.id)
        workCreditsBuy(item?.id)
        setSelectCountPaySuccess('')
    }

    const handleChangePayConfig = (type: string) => {
        setSelectCountPaySuccess('')
        workCreditsBuy(selectCount, type)
    }

    useEffect(() => {
        let isCancelled = false

        if (selectCountPayObj?.id) {
            const timeOutFun = async () => {
                const reCall = () => {
                    timer.current = setTimeout(async () => {
                        await timeOutFun()
                    }, 3000)
                }
                await getOrderStatus({
                    order_id: selectCountPayObj?.id
                }).then(res => {
                    if (res?.status === 'created') {
                        if (isCancelled) return
                        reCall()
                    } else if (res?.status === 'paid') {
                        setSelectCountPaySuccess('paid')
                        markSixEight618PaymentCompleted()
                        clearTimeout(timer.current)
                    } else if (res?.status === 'expired') {
                        setSelectCountPaySuccess('expired')
                        clearTimeout(timer.current)
                    } else if (res?.status === 'error') {
                        messageApi.open({
                            type: 'error',
                            content: res?.err_msg || '支付失败',
                        });
                        clearTimeout(timer.current)
                    } else {
                        reCall()
                    }
                }).catch(err => {
                    messageApi.open({
                        type: 'error',
                        content: err,
                    });

                    clearTimeout(timer.current)
                })
            }
            timeOutFun()
        } else {
            clearTimeout(timer.current)
        }
        return () => {
            isCancelled = true
            clearTimeout(timer.current)
        }
    }, [selectCountPayObj?.id])

    useEffect(() => {
        const workGetCreditsItems = async () => {
            const result = await getCreditsItems().catch(err => {
                messageApi.open({
                    type: 'error',
                    content: err,
                });
            });
            if (Array.isArray(result) && result.length) {
                setCountList(result)
                setSelectCount(result[0]?.id)
            } else {
                setCountList([])
            }
        };
        // 点数 列表
        workGetCreditsItems();
    }, [])

    useEffect(() => {
        if (open && Array.isArray(countList) && countList?.length) {
            setSelectCount(countList[0]?.id)
            workCreditsBuy(countList[0]?.id)
        }
    }, [open, countList])

    const callbackDebounceHandleClick = React.useCallback(debounce((item) => handleCountSelect(item), 300), []);
    
    return <Modal
        className="price-model"
        width={'860px'}
        title={null}
        footer={null}
        open={open}
        maskClosable={false}
        onCancel={() => {
            setOpen(false)
            setSelectCountPayObj({})
            setSelectCountPaySuccess('')
        }}
        destroyOnHidden
        style={{ zIndex: 999 }}
    >
        <div className="price-model-header">
            <div className="price-model-header-left" style={{display: isPc ? "flex" : "none"}}>
                <img style={{ width: '50px', height: '50px', marginRight: '12px' }} src={userOtherInfo?.avatar} alt="avator" />
                <span className="price-model-header-left-text">{userOtherInfo?.name}</span>
            </div>
            <div className="price-model-header-right">
                <span className="price-model-header-right-text">我的算力：</span>
                <img style={{ width: '16px', height: '16px', marginRight: '6px' }} src={PAY} />
                <span className="price-model-header-right-text" style={{ color: '#376BFF', fontWeight: 500 }} >{payCountObj?.recharge?.pay + payCountObj?.subscribe?.pay + payCountObj?.gift?.pay + payCountObj?.old?.pay}点</span>
                <Divider type="vertical" style={{ background: '#4e5155' }} />
                <span className="price-model-header-right-text" onClick={handleOpenCompute}>{'明细 >'}</span>
            </div>
        </div>
        <div className="price-model-body">
            <div className="price-model-body-title">
                <span>购买算力</span>
            </div>
            
            {/* <div style={{ width: '100%', height: '250px', textAlign: 'center', lineHeight: '250px', color: '#ffffff', fontSize: '18px' }}>
                <span>敬请期待！</span>
            </div> */}
            {/* 12.1暂时隐藏 */}
            <div className="price-model-body-content" style={{ marginTop: '12px', flexDirection: isPc ? "row" : "column" }}>
                <div className="price-model-body-content-list" style={{ width: isPc ? "540px" : '80vw', justifyContent: isPc ? "unset" : "center" ,marginBottom: isPc ? "" : "10vw" }}>
                    {
                        countList?.length
                            ? countList.map(item => (
                                <div key={item?.id} className={`price-model-body-content-item ${selectCount === item?.id ? 'content-item-select' : ''}`} onClick={() => callbackDebounceHandleClick(item)}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <img style={{ width: '20px', height: '20px', marginRight: '8px' }} src={PAY} />
                                        <span className="price-model-body-content-item-text">{item?.credits}</span>
                                    </div>
                                    <div className="price-model-body-content-des">
                                        <span>￥{Number(item?.price / 100)?.toFixed(2)}</span>
                                    </div>
                                </div>
                            ))
                            : null
                    }
                </div>
                {
                    selectCountPayObj?.url
                        ? (
                            <div className="iframe-wapper" style={{ marginRight: '8px' }} key={selectCount}>
                                {
                                    selectCountPaySuccess === 'paid'
                                        ? (
                                            <div className="iframe-cover">
                                                <img className='iframe-cover-img' style={{ width: '24px', height: '24px', marginRight: '4px' }} src={SUCCESS} /><span>已购买</span>
                                            </div>
                                        )
                                        : selectCountPaySuccess === 'expired'
                                            ? (
                                                <div className="iframe-cover" style={{ flexDirection: 'column' }}>
                                                    <img style={{ width: '32px', height: '32px' }} src={LOAD} />
                                                    <span style={{ marginTop: '6px' }}>二维码已失效，请刷新重试</span>
                                                    <Button style={{ marginTop: '24px' }} type="primary" onClick={() => { setSelectCountPaySuccess(''); workCreditsBuy(selectCount) }}>刷新</Button>
                                                </div>
                                            )
                                            : null
                                }
                                {
                                    payConfig === "ALP"
                                        ? (
                                            <iframe className="my-iframe" style={{}} src={selectCountPayObj?.url}>
                                            </iframe>
                                        )
                                        : (
                                            <div className="my-iframe" style={{ borderWidth: '10px', borderRadius: '12px' }}>
                                                <QRCodeSVG
                                                    value={selectCountPayObj?.url} 
                                                    size={222} 
                                                />
                                            </div>  
                                        )
                                }
                                
                            </div>
                        )
                        : null
                }
            </div>
            <div className="price-model-body-footer" style={{ marginTop: '12px', flexDirection: isPc ? "row" : "column-reverse", alignItems: isPc ? "flex-end" : "center" }}>
                <div className="price-model-body-footer-left">
                    <span>温馨提示: 积分不可兑换会员，不可转赠，也不可提现;积分充值后有效期为1年，不支持退款或反向兑换为人民币 </span>
                </div>
                <div className="price-model-body-footer-right">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }} onClick={payConfig === 'ALP' ? () => {} : () => handleChangePayConfig('ALP')}> 
                            {payConfig === 'ALP' ? <span>请支付宝扫码支付</span> : <span style={{ color: '#376BFF', textDecoration: 'underline', cursor: 'pointer' }}>切换为支付宝支付</span>}
                            <img style={{ width: '16px', height: '16px', marginLeft: '4px' }} src={PAY_ICON} />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '8px' }} onClick={payConfig === 'WXP' ? () => {} : () => handleChangePayConfig('WXP')}>
                            {payConfig === 'WXP' ? <span>请微信扫码支付</span> : <span style={{ color: '#376BFF', textDecoration: 'underline', cursor: 'pointer' }}>切换为微信支付</span>}
                            <img style={{ width: '16px', height: '16px', marginLeft: '4px' }} src={WX_PAY_ICON} /> 
                        </div>
                    </div>
                    {/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#ffffff' }}>
                        <span>请扫码完成支付</span>
                        <img style={{ width: '16px', height: '16px', marginLeft: '4px' }} src={PAY_ICON} />
                    </div> */}
                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', lineHeight: '16px' }}>
                        <span style={{ color: '#808285' }}>支付即代表同意</span><a href={PAY_LINK} target="_blank" rel="noreferrer"><span style={{ color: '#aaacae', fontWeight: 500, cursor: 'pointer' }}>《“森宇宙好绘”付费服务协议》</span></a>
                    </div>
                </div>
            </div>
        </div>
    </Modal>
}